import { connect } from 'react-redux';
import TouchScreenOrdersReportComponent from './TouchScreenOrdersReportComponent';
import { touchScreenOrdersReportOperations } from './duck';
import { dashboardOperations } from '../../../duck';

const mapStateToProps = (state) => {
    return {
        ...state,
        login: state.login
    }
};

const mapDispatchToProps = (dispatch) => {
    const updateTitle = (title) => dispatch(dashboardOperations.updateTitle(title));
    const getTouchScreenOrdersStats = (dateFrom, dateTo) => dispatch(touchScreenOrdersReportOperations.getTouchScreenOrdersStats(dateFrom, dateTo));
    return {
        updateTitle, 
        getTouchScreenOrdersStats
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(TouchScreenOrdersReportComponent)